import classNames from 'classnames';

import styles from './FormGroup.module.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
  hidden?: boolean;
}

const FormGroup: React.FC<Props> = ({
  className,
  children,
  hidden = false,
}) => (
  <div
    className={classNames(styles.formGroup, className, {
      [styles.hidden]: hidden,
    })}
  >
    {children}
  </div>
);

export default FormGroup;
